import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path d="M19.5508 14.4112 10.8604 18.76l-6.4488-6.4488 4.3487-8.6903L17.9315 5.24ZM7.636 1.3934 1.9792 12.7071l8.4853 8.4853 11.3137-5.6569-2.1213-12.0208Z" />,
  'Polygon',
);
